// Shared badge preview data for consistent display across BadgeTemplates and PrintStation
export const BADGE_PREVIEW_DATA = {
  name: 'Albert Kwame Tchalla',
  company: 'Tchalla Solutions', 
  title: 'Senior Developer',
  profession: 'Software Engineer',
  email: 'albert@tchallasolutions.com',
  phone: '+1 (555) 123-4567',
  registrationNumber: 'REG-0001',
};

// Function to get consistent event name for previews
export const getPreviewEventName = (eventName) => {
  return eventName || 'Tech Conference 2025';
};

// Function to format preview data consistently
export const getConsistentPreviewData = (eventName = null) => {
  return {
    ...BADGE_PREVIEW_DATA,
    eventName: getPreviewEventName(eventName),
  };
};

// Shared function to get consistent logo configuration
export const getConsistentLogoConfig = (event) => {
  return {
    logo_url: event?.logo_url,
    logo_position: event?.logo_position || 'top-center',
    logo_shape: event?.logo_shape || 'circular',
    logo_size: event?.logo_size || 60,
    show_registration_number: event?.show_registration_number || false,
    show_attendee_title: event?.show_attendee_title ?? true,
    show_company_name: event?.show_company_name ?? true,
  };
};
